import { render, staticRenderFns } from "./public_footer.vue?vue&type=template&id=7e6f2251&scoped=true&"
var script = {}
import style0 from "./public_footer.vue?vue&type=style&index=0&id=7e6f2251&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6f2251",
  null
  
)

export default component.exports